const excelTemplate = {
  vehicleBulkImport: "file/upload/template_en/Vehicle bulk import template.xlsx",
  batchUpdateLicensePlate: "file/upload/template_en/Batch update license plate number.xlsx",
  powerBatteryInformation: "file/upload/template_en/Power battery information is imported in batches.xlsx",
  faultCode: "file/upload/template/Fault_code_import_template.xlsx",
  terminalCodeOld: "/file/upload/template/TerminalCodeOld.xlsx",
  terminalCode: "file/upload/template_en/Terminal Code.xlsx",
  error: {
    noExcel: "รูปแบบการอัปโหลดไม่ถูกต้อง， โปรดอัปโหลดรูปแบบ XLS หรือ XLSX"
  }
} 
export default excelTemplate